import { AgentFullData, MovieAgent } from "../entry/server/agents";
import { Movie } from "../entry/server/movie";
import { api, ApiResponse } from "../lib/api";

export const agentService = {
    getMovieAgents: async (id: number): Promise<ApiResponse<MovieAgent>> => {
        return await api.get<MovieAgent>({ url: `movie-agents/${id}` });
    },
    getAgents: async (type: 'directors' | 'actors', search: string, page: number): Promise<ApiResponse<AgentFullData[]>> => {
        return await api.get<AgentFullData[]>({ url: `agents/${type}`, queryParams: { search, page: page.toString() } });
    },
    getAgentDetails: async (type: 'directors' | 'actors', slug: string): Promise<ApiResponse<AgentFullData>> => {
        return await api.get<AgentFullData>({ url: `agents/${type}/${slug}` });
    },
    getAgentMovies: async (type: 'directors' | 'actors', slug: string, page: number): Promise<ApiResponse<Movie[]>> => {
        return await api.get<Movie[]>({ url: `agents/${type}/${slug}/movies`, queryParams: { page: page.toString() } });
    },
};